<template>
  <section>
    <div v-loading="permissionsLoading">
      <div class="role-selection-container">
        <el-row align="middle" type="flex" justify="start">
          <el-col :span="4" class="role-label">Select Role:</el-col>
          <el-col :span="8">
            <el-select
              v-model="selectedRole"
              placeholder="Select Role"
              filterable
              clearable
              class="role-select"
              @change="onRoleChange"
            >
              <el-option
                v-for="role in allRoles"
                :key="role._id"
                :label="role.name"
                :value="role._id"
              />
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div v-if="selectedEntityId">
        <el-row class="mb-1">
          <b class="ml-3">All permissions</b>
          <div class="float-right mr-2">
            <el-button
              class="add-permission-btn"
              size="mini"
              type="primary"
              @click="openNewPermissionModal"
            >
              Add new permission
            </el-button>
          </div>
        </el-row>
        <el-row class="edit-permissions">
          <el-scrollbar wrap-style="max-height: 60vh;">
            <el-collapse accordion>
              <el-collapse-item
                v-for="(item, index) of entityPermissions"
                :key="index + '_main'"
                :title="item.name"
                :name="index"
                class="permission-collapse-item"
              >
                <template slot="title" style="border: 1px solid #e4e7ed">
                  <div class="mt-1" v-if="item.type != 'PROFILE'" style="width: 100%">
                    <el-tooltip :content="item.name">
                      <span style="padding: 0px !important">
                        {{ item.name | truncate(16, '...') }}
                      </span>
                    </el-tooltip>
                    <el-link
                      class="mr-1 ml-2"
                      type="danger"
                      :underline="false"
                      @click="deletePermission(index)"
                    >
                      <i class="el-icon-delete"></i>
                    </el-link>
                    <div style="float: right !important ; margin-right: 90px" class="d-flex">
                      <el-checkbox-group
                        v-if="entityPermissions[index] && entityPermissions[index]['permissions']"
                        v-model="entityPermissions[index]['permissions']"
                        @change="(changedValue) => updateAllpermissions(changedValue, item)"
                      >
                        <el-checkbox label="VIEW"></el-checkbox>
                        <el-checkbox label="ADD"></el-checkbox>
                        <el-checkbox label="EDIT"></el-checkbox>
                        <el-checkbox label="DELETE"></el-checkbox>
                        <el-checkbox label="IMPORT"></el-checkbox>
                        <el-checkbox label="EXPORT"></el-checkbox>
                        <el-checkbox label="ROW DATA EDIT"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </template>
                <el-row align="middle" justify="center">
                  <div class="permissions-container">
                    <div class="permission-section">
                      <el-col :span="24">
                        <!-- <div v-if="item.type != 'PROFILE'"> -->
                        <div>
                          <h4>Other permissions</h4>
                          <el-checkbox-group
                            v-if="
                              entityPermissions[index] && entityPermissions[index]['permissions']
                            "
                            v-model="entityPermissions[index]['permissions']"
                          >
                            <el-checkbox label="VIEW"></el-checkbox>
                            <el-checkbox label="BULK UPDATE"></el-checkbox>
                            <el-checkbox label="BULK DOWNLOAD"></el-checkbox>
                            <el-checkbox label="SEND NOTIFICATION"></el-checkbox>
                            <el-checkbox label="BULK DOWNLOAD DOCUMENTS"></el-checkbox>
                            <el-checkbox label="DOCUMENT"></el-checkbox>
                            <el-checkbox label="LAYOUT"></el-checkbox>
                            <el-checkbox label="LAYOUT OPTIONS"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </el-col>
                    </div>
                    <div class="permission-section">
                      <el-col :span="24" v-if="!addingFilesLoading">
                        <div>
                          <h4>File permissions</h4>
                          <el-checkbox-group
                            v-if="entityPermissions[index] && entityPermissions[index]['files']"
                            v-model="entityPermissions[index]['files']"
                          >
                            <el-checkbox label="VIEW"></el-checkbox>
                            <el-checkbox label="ADD"></el-checkbox>
                            <el-checkbox label="DOWNLOAD"></el-checkbox>
                            <el-checkbox label="DELETE"></el-checkbox>
                            <el-checkbox label="RENAME"></el-checkbox>
                            <el-checkbox label="SHARE"></el-checkbox>
                            <el-checkbox label="SETTINGS"></el-checkbox>
                            <el-checkbox label="BULK DELETE"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </el-col>

                      <el-col :span="24" v-else v-loading="addingFilesLoading">
                        Loading files permissions
                      </el-col>
                    </div>
                  </div>
                  <el-col :span="24" class="mt-2">
                    <el-table
                      v-if="item.templates"
                      :data="Object.keys(item.templates)"
                      style="width: 100%"
                    >
                      <el-table-column label="Template" min-width="300">
                        <template slot-scope="scope">
                          <span>{{ getTemplateLabel(scope.row) }}</span>
                          <el-tooltip content="Manage Field Permissions" placement="top">
                            <i
                              class="el-icon-setting icon-class ml-1"
                              @click="openTemplateSettings(item.entity_id, index, scope.row)"
                            ></i>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        v-for="per in ['VIEW', 'ADD', 'EDIT', 'BULK UPDATE']"
                        :label="per"
                        :key="per + 'per'"
                        min-width="180"
                      >
                        <template slot-scope="scope">
                          <el-checkbox
                            v-if="item.type === 'PROFILE'"
                            :label="per"
                            v-model="entityPermissions[index]['templates'][scope.row]"
                            @change="
                              (changedValue) =>
                                updateProfilepermissions(changedValue, item, scope.row)
                            "
                            :disabled="
                              checkProfileDisabled(
                                entityPermissions[index]['templates'],
                                per,
                                entityPermissions[index]['templates'][scope.row]
                              )
                            "
                          ></el-checkbox>
                          <el-checkbox
                            v-else
                            :label="per"
                            v-model="entityPermissions[index]['templates'][scope.row]"
                            @change="(changedValue) => updateChildpermissions(changedValue, item)"
                            :disabled="
                              (entityPermissions[index] &&
                                entityPermissions[index]['permissions'] &&
                                entityPermissions[index]['permissions'].indexOf(per) === -1) ||
                              checkDisabled(
                                entityPermissions[index]['templates'],
                                per,
                                entityPermissions[index]['templates'][scope.row],
                                item
                              ) ||
                              (per == 'ADD' && scope.$index == 0)
                            "
                          ></el-checkbox>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
          </el-scrollbar>
        </el-row>
        <el-row class="float-right mt-2 save-buttons mb-2">
          <el-button size="mini" @click="close">Cancel</el-button>
          <el-button type="primary" size="mini" @click="addPermissionSet">
            {{ addOrUpdateLabel }}
          </el-button>
        </el-row>
      </div>
      <div v-else>Invalid action</div>
      <dialog-component
        :visible="showNewPermissionModal"
        :title="'Add new permission'"
        :containerWidth="'40%'"
        @before-close="closeNewPermissionModal"
      >
        <div class="Add-Permission">
          Relational entities
          <el-select
            placeholder="Select relational entities"
            v-model="relationalEntities"
            style="width: 100%"
            multiple
            collapse-tags
            class="mb-1"
            filterable
          >
            <el-option
              v-for="(en, index) in (this.getAllEntities?.data || []).filter(
                (e) => relationshipEntities.indexOf(e._id) != -1
              )"
              :key="index + en._id"
              :label="en.name"
              :value="en._id"
              :disabled="checkRelationalExist(en._id, 'RELATIONAL')"
            ></el-option>
          </el-select>
          Other entities
          <el-select
            placeholder="Select other entities"
            v-model="newEntities"
            style="width: 100%"
            multiple
            collapse-tags
            filterable
            class="mb-1"
          >
            <el-option
              v-for="(en, index) in this.getAllEntities?.data || []"
              :key="index + en._id"
              :label="en.name"
              :value="en._id"
              :disabled="checkRelationalExist(en._id, 'OTHER_ENTITY')"
            ></el-option>
          </el-select>
          Nested relational entities
          <el-select
            placeholder="Select relational entities"
            v-model="nestedRelationalEntities"
            style="width: 100%"
            multiple
            collapse-tags
            class="mb-1"
            filterable
          >
            <el-option
              v-for="(en, index) in nestedRelationshipEntities || []"
              :key="index + en.id"
              :label="en.relationship_title"
              :value="en.key"
              :disabled="checkNestedRelationalExist(en.key)"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeNewPermissionModal" size="mini">Close</el-button>
          <el-button @click="AddNewPermissionModal" size="mini" type="primary">Add</el-button>
        </span>
      </dialog-component>
    </div>
    <dialog-component
      :title="'Field Level Permissions'"
      :visible="fieldLevelPermissionsModal"
      @before-close="saveCustomization"
      :isShowFooter="false"
      :containerWidth="'40%'"
    >
      <div>
        <FieldLevelPermissions
          :templateData="selectedTemplateFields"
          :customization="selectedTemplateCustomization"
          @updateCustomization="handleUpdate"
        ></FieldLevelPermissions>
      </div>
    </dialog-component>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { groupByKey } from '../../helpers/appHelper';
  import { fetchEntityRelationships } from '@/repo/entityRelationshipsRepo';
  import { postAPICall } from '@/helpers/httpHelper';
  import { fetchEntityById } from '../../repo/entityRepo';
  import { getAllFieldsArrayFromEntity } from '../../utils/formatter';
  import { getAllCompanyTemplatesByPagination } from '@/repo/templatesRepo';
  import TemplateBuilderhelper from '@/mixins/templateBuilderHelper.js';
  export default {
    components: {
      FieldLevelPermissions: () => import('./FieldLevelPermissions'),
    },
    mixins: [TemplateBuilderhelper],
    props: ['entity_id', 'selectedEntityId'],
    data() {
      return {
        permissionsLoading: false,
        activeName: '',
        profile_permissions: {},
        selectedEntity: null,
        permissions: {
          entity_id: '',
          profile_permissions: {},
          entities: {},
        },
        relationshipsData: [],
        entityDetails: {},
        entityPermissions: [],
        allEntityPermissions: {},
        showNewPermissionModal: false,
        newEntities: [],
        relationalEntities: [],
        relationshipEntities: [],
        nestedRelationalEntities: [],
        nestedRelationshipEntities: [],
        existedPermissions: null,
        addingFilesLoading: true,
        selectedRole: '',
        selectedRoleName: '',
        allRoles: [],
        role_permissions: {},
        rolePermissionsArray: [],
        selectedTemplate: null,
        selectedEntityIdForCustomization: null,
        selectedTemplateCustomization: null,
        fieldLevelPermissionsModal: false,
        selectedEntityIndex: null,
        getAllFormTemplatesData: [],
        selectedTemplateFields: [],
      };
    },
    computed: {
      ...mapGetters('entities', ['getEntityDataById', 'getAllEntities']),
      ...mapGetters('entityRelationships', [
        'getEntityRelationships',
        'getEntityNestedRelationships',
      ]),
      ...mapGetters('companyTemplates', ['getAllCompanyTemplatesData']),
      ...mapGetters('applicationUsersPermission', [
        'getCreatePermissionStatus',
        'getEntityPermission',
        'getAllEntityPermissions',
        'getUpdatePermissionStatus',
      ]),
      rbacTitle() {
        return `RBAC Permissions for ${this.entityDetails?.name || ''}`;
      },
      addOrUpdateLabel() {
        const exists = this.getAllEntityPermissions?.some(
          (item) => item.role_id === this.selectedRole
        );
        return exists ? 'Update' : 'Add';
      },
    },
    async mounted() {
      if (this.selectedEntityId) {
        this.permissionsLoading = true;
        let [fetchedEntityRelationships, fetchedCompanyTemplates] = await Promise.all([
          fetchEntityRelationships({
            entity_id: this.selectedEntityId,
          }),
          getAllCompanyTemplatesByPagination({
            get_all: true,
            include_standard: true,
          }),
          this.$store.dispatch('applicationUsersPermission/fetchAllPermissionsEntityById', {
            id: this.selectedEntityId,
          }),
          this.$store.dispatch('entities/fetchEntities', {
            get_all: true,
            populateData: true,
          }),
          this.$store.dispatch('companyTemplates/getAllCompanyTemplates', {
            get_all: true,
            include_standard: true,
            populateData: true,
          }),
          this.$store.dispatch('entityRelationships/fetchEntityNestedRelationships', {
            entity_id: this.selectedEntityId,
            fetchAll: true,
          }),
        ]);
        this.getAllFormTemplatesData = fetchedCompanyTemplates;
        if (this.getAllEntities && this.getAllEntities?.data) {
          this.entityDetails = await fetchEntityById(this.selectedEntityId);
          if (this.entityDetails && this.entityDetails?.login_mode === 'rbac') {
            let roleDetails = [];
            if (Array.isArray(this.entityDetails?.role_details)) {
              roleDetails = this.entityDetails.role_details;
            } else if (
              this.entityDetails?.role_details &&
              typeof this.entityDetails.role_details === 'object'
            ) {
              roleDetails = [this.entityDetails.role_details];
            }
            for (const role of roleDetails) {
              const entity_id = role.roleEntity;
              const roleName = role.roleName;
              const roleLevel = role.roleLevel || null; // optional
              const entityData = await this.fetchEntityData(entity_id, roleLevel);
              const roles = await this.filterRolesData(entityData, roleName, roleLevel);
              this.allRoles.push(
                ...roles.map((role) => ({
                  ...role,
                  entityId: entity_id,
                }))
              );
              this.selectedRole = this.allRoles[0]?._id || '';
              const selected = this.allRoles.find((r) => r._id === this.selectedRole);
              this.selectedRoleName = selected ? selected.name : '';
              await this.filterPermissionsByRole();
            }
          }
          if (this.getAllEntityPermissions?.length) {
            const rolePermissions = this.getAllEntityPermissions.find(
              (item) => item.role_id === this.selectedRole
            );
            this.existedPermissions = { ...rolePermissions };
          }
          this.getAllEntities.data.forEach((entity) => {
            this.$set(this.allEntityPermissions, entity._id, {});
            let templatesIds = entity?.templates.flatMap((e) => e.template_id);
            let obj = {};
            templatesIds.forEach((te) => {
              if (entity._id == this.selectedEntityId) {
                this.$set(obj, te, ['ADD', 'VIEW', 'EDIT', 'BULK UPDATE']);
              }
              this.$set(this.allEntityPermissions[entity._id], te, [
                'ADD',
                'VIEW',
                'EDIT',
                'BULK UPDATE',
              ]);
            });
            if (
              entity._id == this.selectedEntityId &&
              (!this.existedPermissions || !this.existedPermissions?.profile_permissions)
            ) {
              this.entityPermissions.unshift({
                name: 'Profile permissions',
                entity_id: this.selectedEntityId,
                templates: obj,
                type: 'PROFILE',
              });
            }
          });
          if (fetchedEntityRelationships) {
            this.fetchedRelationships = [...(fetchedEntityRelationships || [])];
            this.setRelationshipPermissions();
          }
        }
        this.permissionsLoading = false;
      }
    },
    methods: {
      async handleUpdate(newCustomization) {
        try {
          if (!this.selectedEntityIdForCustomization || !this.selectedTemplate._id) return;
          let entity;
          if (this.selectedEntityIndex !== undefined) {
            entity = this.entityPermissions[this.selectedEntityIndex];
          } else if (this.selectedEntityIdForCustomization) {
            entity = this.entityPermissions?.find(
              (e) => e.entity_id === this.selectedEntityIdForCustomization
            );
          }
          if (!entity) return;

          if (!entity.templates_customization) {
            this.$set(entity, 'templates_customization', {});
          }
          this.$set(entity.templates_customization, this.selectedTemplate._id, newCustomization);

          this.fieldLevelPermissionsModal = false;
        } catch (err) {
          return err;
        }
      },
      saveCustomization() {
        this.fieldLevelPermissionsModal = false;
      },

      async openTemplateSettings(entityId, index, templateId) {
        try {
          if (entityId) {
            this.selectedEntityIdForCustomization = entityId;
          }
          this.selectedEntityIndex = index;
          if (entityId && templateId) {
            let currentEntity = await fetchEntityById(entityId);
            let currentTemplate = currentEntity.templates.find((t) => t.template_id === templateId);
            let customization = currentTemplate?.customization || {};
            let fields = currentTemplate?.templateInfo?.sections[0].fields || [];
            let customizedFields = await this.applyCustomizationOnFields(fields, customization);
            let primaryFields = currentEntity?.primaryFields || [];
            this.selectedTemplateFields = customizedFields.map((fl) => {
              const isPrimary = primaryFields.some((pf) => pf.key === fl.key);
              return {
                ...fl,
                isPrimary: !!isPrimary,
              };
            });
            this.selectedTemplate = currentTemplate?.templateInfo;
            const entity = this.entityPermissions[index];
            const existingCustomization = entity?.templates_customization?.[templateId] || {};
            this.selectedTemplateCustomization = JSON.parse(JSON.stringify(existingCustomization));
          }
          this.fieldLevelPermissionsModal = true;
        } catch (err) {
          return err;
        }
      },
      onRoleChange() {
        try {
          const selected = this.allRoles.find((r) => r._id === this.selectedRole);
          this.selectedRoleName = selected ? selected.name : '';
        } catch (err) {
          return err;
        }
      },
      filterPermissionsByRole() {
        if (this.getAllEntityPermissions?.length) {
          this.entityPermissions = [];
          const roleData = this.getAllEntityPermissions.find(
            (item) => item.role_id === this.selectedRole
          );
          if (!roleData) {
            this.setDefaultPermissions();
            return;
          }
          this.existedPermissions = roleData;
          // Profile permissions
          if (roleData.profile_permissions) {
            this.entityPermissions.push({
              ...roleData.profile_permissions,
            });
          }

          // Relational entities
          if (roleData.relational_entities) {
            Object.keys(roleData.relational_entities).forEach((entityId) => {
              this.entityPermissions.push({
                ...roleData.relational_entities[entityId],
              });
            });
          }

          // Other entities
          if (roleData.other_entities) {
            Object.keys(roleData.other_entities).forEach((entityId) => {
              this.entityPermissions.push({
                ...roleData.other_entities[entityId],
              });
            });
          }

          // Nested relational entities
          if (roleData.nested_relational_entities) {
            Object.keys(roleData.nested_relational_entities).forEach((entityKey) => {
              const [, entityId] = entityKey.split('#');
              this.entityPermissions.push({
                ...roleData.nested_relational_entities[entityId],
              });
            });
          }
        } else {
          this.entityPermissions = [];
          this.setDefaultPermissions();
        }
      },
      async fetchEntityData(entity_id, level = null) {
        try {
          let currentEntity = await fetchEntityById(entity_id);
          let template_fields_data = await getAllFieldsArrayFromEntity(currentEntity);
          let params = {
            entity_id: entity_id,
            template_fields_data: template_fields_data,
            format_data: true,
            filters: [],
            sortBy: level ? level : undefined,
            sortOrder: 'asc',
            limit: 500,
            page: 1,
          };
          let response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
          if (response.data && Array.isArray(response.data.data) && response.data.data?.length) {
            return response?.data?.data;
          } else {
            return [];
          }
        } catch (err) {
          return err;
        }
      },
      async filterRolesData(data, roleName, roleLevel = null) {
        try {
          let templateId = roleName.split('#')[0];
          let role_name = roleName.split('#')[1];
          let role_level = roleLevel ? roleLevel.split('#')[1] : null;
          return (
            data?.map((item) => {
              const role = item.entityData[templateId];
              return {
                _id: item._id,
                name: role[role_name],
                level: role_level ? role[role_level] : null,
              };
            }) || []
          );
        } catch (err) {
          return [];
        }
      },
      removeNotExistedTemplates(permissions, templates) {
        Object.keys(permissions.templates || {}).forEach((t) => {
          let existed = (templates || []).find((e) => t == e.template_id);
          if (!existed) {
            delete permissions.templates[t];
          }
        });
        return permissions;
      },
      close() {
        this.$emit('close');
      },
      checkProfileDisabled(templates, per, value) {
        if (templates && Object.keys(templates) && per == 'VIEW') {
          let viewIndex = [];
          Object.keys(templates).forEach((te) => {
            if (templates[te].indexOf('VIEW') > -1) {
              viewIndex.push(templates[te].indexOf('VIEW'));
            }
          });
          if (viewIndex?.length == 1 && value?.length) {
            return true;
          }
        }
        return false;
      },
      async addPermissionSet() {
        try {
          if (!this.selectedRole) {
            this.$message.error('please select the Role');
            return;
          }
          // 1. Extract permissions by type
          let profilePermissions = this.entityPermissions.find(
            (e) => e.entity_id === this.selectedEntityId && e.type === 'PROFILE'
          );

          let relationalEntities = this.entityPermissions.filter((e) => e.type === 'RELATIONAL');
          let nestedRelationalEntities = this.entityPermissions.filter(
            (e) => e.type === 'NESTED_RELATIONAL'
          );
          let otherEntities = this.entityPermissions.filter((e) => e.type === 'OTHER_ENTITY');

          let relationalEntitiesObj = relationalEntities?.length
            ? groupByKey(relationalEntities, 'entity_id')
            : {};

          let nestedRelationalEntitiesObj = nestedRelationalEntities?.length
            ? groupByKey(nestedRelationalEntities, 'key')
            : {};

          let otherEntitiesObj = otherEntities?.length
            ? groupByKey(otherEntities, 'entity_id')
            : {};

          let selectedRoleObj = this.allRoles.find((role) => role._id === this.selectedRole);
          this.selectedRoleName = selectedRoleObj ? selectedRoleObj.name : this.selectedRole;
          const rolePermissions = this.getAllEntityPermissions.find(
            (item) => item.role_id === this.selectedRole
          );
          this.existedPermissions = { ...rolePermissions };
          let permissionObj = {
            role_id: this.selectedRole,
            role_name: this.selectedRoleName,
            profile_permissions: profilePermissions,
            relational_entities: relationalEntitiesObj,
            nested_relational_entities: nestedRelationalEntitiesObj,
            other_entities: otherEntitiesObj,
            entity_id: this.selectedEntityId, // if needed
          };
          if (!this.rolePermissionsArray) this.rolePermissionsArray = [];
          const index = this.rolePermissionsArray.findIndex(
            (p) => p.role_id === permissionObj.role_id
          );
          if (index !== -1) {
            this.rolePermissionsArray.splice(index, 1, permissionObj); // Replace
          } else {
            this.rolePermissionsArray.push(permissionObj); // Add
          }

          if (this.existedPermissions?._id) {
            permissionObj.id = this.existedPermissions._id;
            await this.$store.dispatch(
              'applicationUsersPermission/updateEntityPermissions',
              permissionObj
            );
            this.$store.dispatch('applicationUsersPermission/fetchAllPermissionsEntityById', {
              id: this.selectedEntityId,
            });
            if (this.getUpdatePermissionStatus) {
              this.$notify({
                title: 'Success',
                message: 'Entity permissions updated successfully',
                type: 'success',
              });
            } else {
              this.$notify({
                title: 'Error',
                message: 'Error while updating permissions',
                type: 'error',
              });
            }
          } else {
            await this.$store.dispatch(
              'applicationUsersPermission/createEntityPermissions',
              permissionObj
            );
            await this.$store.dispatch('applicationUsersPermission/fetchAllPermissionsEntityById', {
              id: this.selectedEntityId,
            });
            if (this.getCreatePermissionStatus) {
              this.$notify({
                title: 'Success',
                message: 'Entity permissions created successfully',
                type: 'success',
              });
            } else {
              this.$notify({
                title: 'Error',
                message: 'Error while creating permissions',
                type: 'error',
              });
            }
          }
          this.permissionsLoading = false;
          this.selectedRole = '';
        } catch (err) {
          return err;
        }
      },
      async onSave() {
        this.$emit('close');
      },
      checkDisabled(templates, permission, data) {
        if (permission == 'BULK UPDATE' || permission == 'ADD') {
          return false;
        }
        let allIndex = [];
        Object.keys(templates).forEach((te) => {
          if (templates[te]) {
            let index = templates[te].indexOf(permission);
            if (index > -1) {
              allIndex.push(index);
            }
          }
        });
        if (allIndex && allIndex?.length == 1) {
          if (data && data.indexOf(permission) == -1) {
            return false;
          }
          return true;
        }
        return false;
      },
      updateProfilepermissions(permission, item, key) {
        if (item && item?.templates && item.templates[key]) {
          if (item.templates[key].indexOf('VIEW') == -1) {
            item.templates[key] = [];
          }
        }
      },
      updateChildpermissions(permission, item) {
        if (item?.templates && item.type != 'PROFILE') {
          let viewIndex = [];
          let editIndex = [];
          let bulkUpdateIndex = [];
          let addIndex = [];
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              viewIndex.push(item.templates[te].indexOf('VIEW'));
              editIndex.push(item.templates[te].indexOf('EDIT'));
              bulkUpdateIndex.push(item.templates[te].indexOf('BULK UPDATE'));
              addIndex.push(item.templates[te].indexOf('ADD'));
            }
          });
          if (viewIndex.every((e) => e == -1 || e == '-1')) {
            let mainViewIndex = item.permissions.indexOf('VIEW');
            if (mainViewIndex > -1) {
              item.permissions.splice(mainViewIndex, 1);
            }
          }
          if (editIndex.every((e) => e == -1 || e == '-1')) {
            let editViewIndex = item.permissions.indexOf('EDIT');
            if (editViewIndex > -1) {
              item.permissions.splice(editViewIndex, 1);
            }
          }
          if (bulkUpdateIndex.every((e) => e == -1 || e == '-1')) {
            let mainBulkUpdateIndex = item.permissions.indexOf('BULK UPDATE');
            if (mainBulkUpdateIndex > -1) {
              item.permissions.splice(mainBulkUpdateIndex, 1);
            }
          }
          if (addIndex.every((e) => e == -1 || e == '-1')) {
            let mainAddIndex = item.permissions.indexOf('ADD');
            if (mainAddIndex > -1) {
              item.permissions.splice(mainAddIndex, 1);
            }
          }
        }
      },
      updateAllpermissions(permissions, item) {
        if (
          permissions.indexOf('VIEW') == -1 &&
          (permissions.indexOf('EDIT') != -1 || permissions.indexOf('ADD') != -1)
        ) {
          item.permissions = [...permissions, ...['VIEW']];
          permissions = [...permissions, ...['VIEW']];
        }
        if (permissions.indexOf('VIEW') == -1 && item?.templates) {
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              let index = item.templates[te].indexOf('VIEW');
              if (index > -1) {
                item.templates[te].splice(index, 1);
              }
            }
          });
        }
        if (permissions.indexOf('EDIT') == -1 && item?.templates) {
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              let index = item.templates[te].indexOf('EDIT');
              if (index > -1) {
                item.templates[te].splice(index, 1);
              }
            }
          });
        }
        if (permissions.indexOf('BULK UPDATE') == -1 && item?.templates) {
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              let index = item.templates[te].indexOf('BULK UPDATE');
              if (index > -1) {
                item.templates[te].splice(index, 1);
              }
            }
          });
        } else {
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              item.templates[te] = [...item.templates[te], ...['BULK UPDATE']];
            }
          });
        }
        if (permissions.indexOf('ADD') == -1 && item?.templates) {
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              let index = item.templates[te].indexOf('ADD');
              if (index > -1) {
                item.templates[te].splice(index, 1);
              }
            }
          });
        } else {
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              item.templates[te] = [...item.templates[te], ...['ADD']];
            }
          });
        }
        if (permissions.indexOf('VIEW') !== -1 && item?.templates) {
          let viewIndex = [];
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              let index = item.templates[te].indexOf('VIEW');
              viewIndex.push(index);
            }
          });
          if (viewIndex.every((e) => e == -1 || e == '-1')) {
            Object.keys(item.templates).forEach((te) => {
              if (item.templates[te]) {
                item.templates[te] = [...item.templates[te], ...['VIEW']];
              }
            });
          }
        }
        if (permissions.indexOf('EDIT') !== -1 && item?.templates) {
          let editIndex = [];
          Object.keys(item.templates).forEach((te) => {
            if (item.templates[te]) {
              let index = item.templates[te].indexOf('EDIT');
              editIndex.push(index);
            }
          });
          if (editIndex.every((e) => e == -1 || e == '-1')) {
            Object.keys(item.templates).forEach((te) => {
              if (item.templates[te]) {
                item.templates[te] = [...item.templates[te], ...['EDIT']];
              }
            });
          }
        }
      },
      checkNestedRelationalExist(key) {
        if (this.entityPermissions?.length) {
          return this.entityPermissions.find((e) => e.key == key && e.type == 'NESTED_RELATIONAL')
            ? true
            : false;
        }
        return false;
      },
      checkRelationalExist(id, type) {
        if (this.entityPermissions?.length) {
          return this.entityPermissions.find((e) => e.entity_id == id && e.type == type)
            ? true
            : false;
        }
        return false;
      },
      deletePermission(index) {
        this.entityPermissions.splice(index, 1);
      },
      AddNewPermissionModal() {
        try {
          if (this.newEntities?.length) {
            this.newEntities.forEach((el) => {
              let selectedEntity = this.getAllEntities?.data.find((e) => e._id == el);
              this.entityPermissions.push({
                entity_id: el,
                name: selectedEntity.name,
                templates: this.getEntityTemplatePermissions(el),
                permissions: [
                  'ADD',
                  'VIEW',
                  'EDIT',
                  'DELETE',
                  'IMPORT',
                  'EXPORT',
                  'BULK UPDATE',
                  'SEND NOTIFICATION',
                  'DOCUMENTS',
                  'LAYOUT',
                  'LAYOUT OPTIONS',
                  'ROW DATA EDIT',
                  'BULK DOWNLOAD',
                  'BULK DOWNLOAD DOCUMENTS',
                ],
                type: 'OTHER_ENTITY',
                files: ['VIEW'],
              });
            });
          }
          if (this.relationalEntities?.length) {
            this.relationalEntities.forEach((el) => {
              let selectedEntity = this.getAllEntities?.data.find((e) => e._id == el);
              this.entityPermissions.push({
                entity_id: el,
                name: 'My ' + selectedEntity.name,
                templates: this.getEntityTemplatePermissions(el),
                permissions: [
                  'ADD',
                  'VIEW',
                  'EDIT',
                  'DELETE',
                  'IMPORT',
                  'EXPORT',
                  'BULK UPDATE',
                  'SEND NOTIFICATION',
                  'LAYOUT',
                  'LAYOUT OPTIONS',
                  'ROW DATA EDIT',
                  'BULK DOWNLOAD',
                  'BULK DOWNLOAD DOCUMENTS',
                ],
                type: 'RELATIONAL',
                files: ['VIEW'],
              });
            });
          }
          if (this.nestedRelationalEntities?.length) {
            this.nestedRelationalEntities.forEach((el) => {
              let relationship = this.nestedRelationshipEntities.find((e) => e.key == el);
              this.entityPermissions.push({
                key: relationship.key,
                name: relationship.relationship_title,
                templates: this.getEntityTemplatePermissions(el.split('#')[1]),
                permissions: [
                  'ADD',
                  'VIEW',
                  'EDIT',
                  'DELETE',
                  'IMPORT',
                  'EXPORT',
                  'BULK UPDATE',
                  'SEND NOTIFICATION',
                  'LAYOUT',
                  'LAYOUT OPTIONS',
                  'ROW DATA EDIT',
                  'BULK DOWNLOAD',
                  'BULK DOWNLOAD DOCUMENTS',
                ],
                type: 'NESTED_RELATIONAL',
                files: ['VIEW'],
              });
            });
          }
          this.closeNewPermissionModal();
        } catch (err) {
          return err;
        }
      },
      closeNewPermissionModal() {
        this.showNewPermissionModal = false;
        this.newEntities = [];
        this.relationalEntities = [];
        this.nestedRelationalEntities = [];
      },
      openNewPermissionModal() {
        this.showNewPermissionModal = true;
      },
      getTemplateLabel(tempId) {
        if (tempId && this.getAllFormTemplatesData?.data) {
          let selectedTemp = this.getAllFormTemplatesData.data.find((e) => e._id == tempId);
          if (selectedTemp?.name) {
            return selectedTemp.name;
          }
        }
        return '';
      },
      getEntityTemplatePermissions(entityId) {
        if (entityId && this.allEntityPermissions[entityId]) {
          return this.allEntityPermissions[entityId];
        }
        return {};
      },
      addFilesPermissions() {
        this.addingFilesLoading = true;
        this.entityPermissions = this.entityPermissions.map((e) => {
          if ((e.entity_id || e.type == 'NESTED_RELATIONAL') && !e.files) {
            this.$set(e, 'files', ['VIEW']);
          }
          return e;
        });
        setTimeout(() => {
          this.addingFilesLoading = false;
        }, 3000);
      },
      setRelationshipPermissions() {
        this.fetchedRelationships.forEach((el) => {
          if (el?.child_entity_id !== this.selectedEntityId) {
            this.relationshipEntities.push(el.child_entity_id);
            if (!this.existedPermissions) {
              this.entityPermissions.push({
                entity_id: el?.child_entity_id,
                name: 'My ' + el?.child_relation_title,
                templates: this.getEntityTemplatePermissions(el?.child_entity_id),
                permissions: [
                  'ADD',
                  'VIEW',
                  'EDIT',
                  'DELETE',
                  'IMPORT',
                  'EXPORT',
                  'BULK UPDATE',
                  'SEND NOTIFICATION',
                  'LAYOUT',
                  'LAYOUT OPTIONS',
                  'ROW DATA EDIT',
                  'BULK DOWNLOAD',
                ],
                type: 'RELATIONAL',
              });
            }
          } else if (this.selectedEntityId !== el?.parent_entity_id) {
            this.relationshipEntities.push(el.parent_entity_id);
            if (!this.existedPermissions) {
              this.entityPermissions.push({
                entity_id: el?.parent_entity_id,
                name: 'My ' + el?.parent_relation_title,
                templates: this.getEntityTemplatePermissions(el?.parent_entity_id),
                permissions: [
                  'ADD',
                  'VIEW',
                  'EDIT',
                  'DELETE',
                  'IMPORT',
                  'EXPORT',
                  'BULK UPDATE',
                  'SEND NOTIFICATION',
                  'ROW DATA EDIT',
                  'BULK DOWNLOAD',
                ],
                type: 'RELATIONAL',
              });
            }
          }
        });
        this.getEntityNestedRelationships.forEach((e) => {
          this.nestedRelationshipEntities.push({
            relationship_title:
              e.parent_relationship_details.relationship_title + '/' + e.relationship_title,
            key: e.parent_relationship_details.relationship_id + '#' + e.relationship_id,
            id: e._id,
          });
        });
        this.addFilesPermissions();
      },

      //--newwww--

      setDefaultPermissions() {
        try {
          this.entityPermissions = this.entityPermissions.filter(
            (perm) => perm.type === 'PROFILE' && perm.entity_id === this.selectedEntityId
          );

          const profileExists = this.entityPermissions.some(
            (perm) => perm.type === 'PROFILE' && perm.entity_id === this.selectedEntityId
          );

          if (!profileExists) {
            const entity = this.getAllEntities?.data.find((e) => e._id === this.selectedEntityId);

            if (!entity) return;

            const templatesIds = entity?.templates.flatMap((e) => e.template_id) || [];
            const templatesObj = {};

            templatesIds.forEach((te) => {
              templatesObj[te] = ['ADD', 'VIEW', 'EDIT', 'BULK UPDATE'];
            });
          }
        } catch (err) {
          return err;
        }
      },
    },
    watch: {
      selectedRole(newVal) {
        const roleExistsInPermissions = this.getAllEntityPermissions?.some(
          (item) => item.role_id === newVal
        );
        if (newVal && this.getAllEntityPermissions?.length && roleExistsInPermissions) {
          const selected = this.allRoles.find((r) => r._id === this.selectedRole);
          this.selectedRole = newVal;
          this.selectedRoleName = selected ? selected.name : '';
          this.filterPermissionsByRole();
        } else {
          this.setDefaultPermissions();
        }
      },
    },
  };
</script>
<style scoped>
  .role-selection-container {
    margin-bottom: 10px;
    margin-left: 10px;
    padding: 5px;
    align-items: left;
    /* background-color: #f9f9f9; */
  }

  .role-label {
    font-weight: bold;
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: left;
    height: 100%;
    width: 100px;
  }

  .role-select {
    width: 100%;
  }

  .add-permission-btn:hover {
    background-color: #007bff !important; /* Customize */
    border-color: #007bff !important;
    color: #fff !important;
    box-shadow: 0 2px 6px rgba(0, 123, 255, 0.4);
  }

  .Add-Permission {
    margin: 20px;
  }
  .edit-permissions {
    width: 100% !important;
    margin-top: 30px;
  }

  .permission-collapse-item {
    border: 2px solid #dcdfe6;
    border-radius: 8px;
    margin-bottom: 16px;
    margin: 0px 5px 16px 5px;
    padding: 12px;
    background-color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  }
  .el-collapse-item__header {
    border-bottom: 0px;
  }

  .save-buttons {
    margin-top: 30px;
    border-radius: 15px;
  }

  .permissions-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .permission-section {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 15px 5px 0px 10px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
  }
</style>
